import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun11am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1.31604C8.34518 1.31604 8.625 1.59586 8.625 1.94104V3.05903C8.625 3.40421 8.34518 3.68403 8 3.68403C7.65482 3.68403 7.375 3.40421 7.375 3.05903V1.94104C7.375 1.59586 7.65482 1.31604 8 1.31604Z"
        fill="currentColor"
      />
      <path
        d="M8 12.316C8.34518 12.316 8.625 12.5959 8.625 12.941V14.059C8.625 14.4042 8.34518 14.684 8 14.684C7.65482 14.684 7.375 14.4042 7.375 14.059V12.941C7.375 12.5959 7.65482 12.316 8 12.316Z"
        fill="currentColor"
      />
      <path
        d="M14.684 8C14.684 8.34518 14.4041 8.625 14.059 8.625H12.941C12.5958 8.625 12.316 8.34518 12.316 8C12.316 7.65482 12.5958 7.375 12.941 7.375H14.059C14.4041 7.375 14.684 7.65482 14.684 8Z"
        fill="currentColor"
      />
      <path
        d="M3.68396 8C3.68396 8.34518 3.40414 8.625 3.05896 8.625H1.94097C1.59579 8.625 1.31597 8.34518 1.31597 8C1.31597 7.65482 1.59579 7.375 1.94097 7.375H3.05896C3.40414 7.375 3.68396 7.65482 3.68396 8Z"
        fill="currentColor"
      />
      <path
        d="M12.7262 3.27376C12.9703 3.51784 12.9703 3.91357 12.7262 4.15764L11.9357 4.94818C11.6916 5.19226 11.2959 5.19226 11.0518 4.94818C10.8077 4.7041 10.8077 4.30838 11.0518 4.0643L11.8424 3.27376C12.0864 3.02968 12.4822 3.02968 12.7262 3.27376Z"
        fill="currentColor"
      />
      <path
        d="M4.94817 11.052C5.19224 11.296 5.19224 11.6918 4.94817 11.9358L4.15763 12.7264C3.91355 12.9705 3.51782 12.9705 3.27374 12.7264C3.02967 12.4823 3.02967 12.0866 3.27374 11.8425L4.06428 11.052C4.30836 10.8079 4.70409 10.8079 4.94817 11.052Z"
        fill="currentColor"
      />
      <path
        d="M12.7263 12.7264C12.4822 12.9704 12.0865 12.9704 11.8424 12.7264L11.0518 11.9358C10.8078 11.6917 10.8078 11.296 11.0518 11.0519C11.2959 10.8079 11.6917 10.8079 11.9357 11.0519L12.7263 11.8425C12.9703 12.0866 12.9703 12.4823 12.7263 12.7264Z"
        fill="currentColor"
      />
      <path
        d="M4.94819 4.94817C4.70412 5.19225 4.30839 5.19225 4.06431 4.94817L3.27377 4.15763C3.02969 3.91355 3.02969 3.51782 3.27377 3.27374C3.51785 3.02967 3.91358 3.02967 4.15766 3.27374L4.9482 4.06428C5.19227 4.30836 5.19227 4.70409 4.94819 4.94817Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5176 9.08496C11.0546 10.5878 9.65492 11.6801 8.00013 11.6801C5.96772 11.6801 4.32013 10.0325 4.32013 8.00007C4.32013 5.96766 5.96772 4.32007 8.00013 4.32007C9.65581 4.32007 11.0561 5.41347 11.5183 6.91759C11.6221 7.24589 11.6802 7.61286 11.6802 8.0001C11.6802 8.38826 11.6219 8.75606 11.5176 9.08496ZM8.00013 10.4301C8.39677 10.4301 8.77122 10.335 9.10194 10.1665C8.6139 9.72121 8.28809 8.91755 8.28809 8.0001C8.28809 7.08263 8.61392 6.27894 9.10199 5.83366C8.77125 5.66511 8.39679 5.57007 8.00013 5.57007C6.65808 5.57007 5.57013 6.65802 5.57013 8.00007C5.57013 9.34212 6.65808 10.4301 8.00013 10.4301Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun11am;
